import { gql, useQuery } from '@apollo/client';
import { FeatureFlagTypes } from '@generated/graphql';
import { useOrganizationFeatureFlags } from '@ovComponents/4-module/featureFlag/featureFlag';
import { useMemo } from 'react';
import { DEFAULT_DRIFT_TOLERANCE_PERCENT } from '../utils/constants';

const FETCH_ORG_DRIFT_TOLERANCE = gql`
  query fetchOrganizationDriftTolerance($organizationId: String!) {
    fetchOrganization(organizationId: $organizationId) {
      organization {
        id
        defaultDriftTolerancePercent
      }
    }
  }
`;

export function usePortfolioDriftTolerance(
  organizationId: string | undefined,
): number {
  const { isFeatureFlagEnabled } = useOrganizationFeatureFlags();
  const isDriftFeatureEnabled = isFeatureFlagEnabled(
    FeatureFlagTypes.DriftToleranceEnabled,
  );

  const { data } = useQuery(FETCH_ORG_DRIFT_TOLERANCE, {
    variables: { organizationId },
    skip: !isDriftFeatureEnabled || !organizationId,
    fetchPolicy: 'cache-first',
  });

  return useMemo(() => {
    if (!isDriftFeatureEnabled || !organizationId) {
      return DEFAULT_DRIFT_TOLERANCE_PERCENT;
    }
    const orgDriftTolerancePercent =
      data?.fetchOrganization?.organization?.defaultDriftTolerancePercent;
    return orgDriftTolerancePercent && orgDriftTolerancePercent > 0
      ? orgDriftTolerancePercent
      : DEFAULT_DRIFT_TOLERANCE_PERCENT;
  }, [isDriftFeatureEnabled, organizationId, data]);
}
